// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.history.conditionrelatedto.ConditionRelatedToResponse */
/* istanbul ignore next */
@GandalfModel
export class ConditionRelatedToResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	accidentDate!: Date | null;

	@GandalfProperty({ designType: String })
	accidentState!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Boolean })
	relatedToAutoAccident!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	relatedToEmployment!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	relatedToOtherAccident!: boolean | null;

	@GandalfProperty({ designType: Number })
	version!: number | null;

}
